<template>
  <div class="content md flex-box">
    <address-book class="org-tree" ref="orgTree" @org="handleOrg" @select="handleSelect"></address-book>
    <div class="flex-grow flex-box vertical org-info" v-if="item">
      <div class="flex-box align-center org-info-top">
        <div class="flex-grow org-top-title">{{ item.name }}</div>
        <a-space v-show="!edit">
          <!-- 非阵地父级（目前只有杭统云E家可添加） -->
          <a-button @click="addDept" v-if="item.isParent && !item.isPosition">添加部门</a-button>
          <!-- 阵地部门 | 部门层级 -->
          <a-button @click="addPerson" v-if="(item.isParent && item.isPosition) || item.isDept">添加成员</a-button>
          <!-- 部门层级 -->
          <a-button type="primary" @click="editDept" v-if="item.isDept">编辑部门</a-button>
          <template v-if="item.isAdmin">
            <a-button @click="changePassword">修改密码</a-button>
            <a-button type="primary" @click="editPerson">编辑成员</a-button>
          </template>
        </a-space>
      </div>
      <div class="flex-grow flex-box vertical org-info-ctx">
        <form-area
          ref="orgForm"
          class="flex-grow flex-box vertical org-form"
          layout="horizontal"
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 20 }"
          :items="items"
          :form="form"
          @cancel="cancel"
          @confirm="confirm"
          v-show="edit && type > 0"
        ></form-area>
        <a-descriptions class="org-detail" title="成员详情" :column="1" v-show="!edit && item.isAdmin" v-if="item">
          <a-descriptions-item label="姓名">{{ item.name }}</a-descriptions-item>
          <a-descriptions-item label="手机号码">{{ item.tel }}</a-descriptions-item>
          <a-descriptions-item label="部门">{{ item.deptName }}</a-descriptions-item>
          <a-descriptions-item label="角色">{{ getRoleTypeText(item.role) }}</a-descriptions-item>
        </a-descriptions>
      </div>
    </div>
  </div>
</template>

<script>
import addressBook from "../components/address-book";
import { deptItems, adminItems, passwordItems, getRoleTypeText, roleTypes } from "../common/constant/org";
import { clone } from "../common/js/tool";

export default {
  name: "Organization",
  components: {
    addressBook,
  },
  data() {
    return {
      ids: [],
      type: null, // 1 部门 2成员
      form: {},
      edit: false,
      item: null,
      groupList: [],
    };
  },
  computed: {
    items() {
      let type = this.type;
      let res = [];
      if (type == 1) {
        res = clone(deptItems);
      } else if (type == 2) {
        res = clone(adminItems);
        let form = this.form;
        const deptItem = res.find((item) => item.key === "dept");
        const roleItem = res.find((item) => item.key === "role");
        deptItem.props.options = this.getDeptOptions();
        roleItem.props.options = this.getRoleOptions();
        // 编辑去除密码编辑
        if (form.id) {
          res.splice(2, 1);
          if (this.isPositionAdmin) {
            // 阵地人员无法变更部门与角色身份
            deptItem.props.disabled = true;
            roleItem.props.disabled = true;
          }
        } else {
          deptItem.props.disabled = true; // 添加时部门固定，无法变更
          if (this.item.isPosition) {
            roleItem.props.disabled = true; // 阵地管理员角色固定
          }
        }
      } else if (type == 3) {
        res = clone(passwordItems);
      }
      return res;
    },
  },
  methods: {
    isPositionAdmin() {
      const [, id] = this.ids[0].split("-");
      const node = this.groupList.find((item) => item.id == id);
      return !!node.position_id;
    },
    getDeptOptions() {
      let list = this.groupList;
      const l = this.form?.id ? this.ids.length - 2 : this.ids.length - 1;
      for (let i = 0; i < l; i++) {
        const [, id] = this.ids[i].split("-");
        const node = list.find((n) => n.id == id);
        list = node.dept_list;
      }
      return list.map((item) => {
        return {
          key: item.id,
          title: item.name,
        };
      });
    },
    getRoleOptions() {
      const list = clone(roleTypes);
      const [type, id] = this.ids[0].split("-");
      if (type == "parent") {
        const node = this.groupList.find((n) => n.id == id);
        if (node.position_id) {
          return list.splice(-1);
        }
      }
      return list.splice(0, 2);
    },
    getRoleTypeText,
    changePassword() {
      this.form = { id: this.item.id };
      this.type = 3;
      this.edit = true;
    },
    addDept() {
      this.form = {};
      this.type = 1;
      this.edit = true;
    },
    editDept() {
      this.form = clone(this.item);
      this.type = 1;
      this.edit = true;
    },
    addPerson() {
      this.form = {
        dept: this.item.id,
      };
      if (this.item.isPosition) {
        this.form.role = 3; // 默认阵地管理员
      }
      this.type = 2;
      this.edit = true;
    },
    editPerson() {
      let person = clone(this.item);
      person.role = person.role * 1;
      this.form = person;
      this.type = 2;
      this.edit = true;
    },
    cancel() {
      this.edit = false;
      this.type = null;
      this.form = {};
    },
    confirm() {
      let form = this.form,
        type = this.type;
      let url;
      if (type == 3) {
        if (form.password == form.second) {
          url = "/admin";
          form = {
            id: form.id,
            password: form.password,
          };
        } else {
          this.$message.warning("两次输入密码不一致");
          return;
        }
      } else if (type == 1) {
        url = "/admin-dept";
      } else if (type == 2) {
        url = "/admin";
      }
      if (!url) return;
      let param = {
        data: form,
      };
      if (form.id) {
        url += `/${form.id}`;
        param.method = "PATCH";
        if (type == 2) {
          delete param.data.password;
        }
      } else {
        if (type == 1) {
          param.fid = form.id; // 部门fid
        }
        param.method = "POST";
      }
      param.url = url;
      this.$axios(param).then((res) => {
        if (form.id) {
          this.item = res;
        }
        this.$message.success(form.id ? "更新成功" : "添加成功");
        this.cancel();
        this.updateList();
      });
    },
    handleOrg(list) {
      this.groupList = list;
    },
    handleSelect(e) {
      let { ids, item } = e;
      this.ids = ids;
      this.item = item;
      this.cancel();
    },
    updateList() {
      this.$refs.orgTree.getList();
    },
  },
};
</script>

<style scoped lang="less">
.org-tree {
  width: 240px;
  border-right: var(--border);
  overflow: auto;
}
.org-detail {
  margin-top: 10px;
}
.org-info {
  padding-left: 16px;
}
.org-info-top {
  padding-bottom: 16px;
  border-bottom: var(--border);
}
.org-top-title {
  font-size: 16px;
}
</style>
